module.exports = __webpack_public_path__ + "img/iphoneFirstSetting.cd52a347.webp";